
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M9.452 20.62l-1.57-1.239A50.463 50.463 0 0118.544 9.316l1.146 1.639A48.401 48.401 0 009.452 20.62zM49 2h13l-5 9h3L49 22l2-10h-3z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M40.59 13.41a2.26 2.26 0 00-1.31-.41C38.02 13 37 14.02 37 15.28V28a4 4 0 01-4-4V2h-4v22a4 4 0 01-4 4V15.28c0-1.26-1.02-2.28-2.28-2.28-.47 0-.93.14-1.31.41A45.58 45.58 0 008.053 28.02C10.513 32.197 14.941 35 20 35a13.48 13.48 0 005-.973V32c2.39 0 4.54-1.05 6-2.71A7.975 7.975 0 0037 32v16.63c0 .916.312 1.788.859 2.484 8.822-2.319 15.888-9.002 18.754-17.591A45.476 45.476 0 0040.59 13.41z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M39.895 52.599L56.49 61.72c.33.18.71.28 1.1.28h.13c1.261 0 2.28-1.02 2.28-2.28v-9.03c0-4.935-.806-9.765-2.323-14.323-3.281 7.67-9.776 13.645-17.782 16.232zM3.533 39.043c-.039.146-.086.29-.123.437C2.48 43.1 2 46.86 2 50.69v9.03C2 60.98 3.02 62 4.28 62h.13c.39 0 .77-.1 1.1-.28l7.98-4.39.432-.238C9.245 53.567 5.505 47.085 3.533 39.043z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M20 37c-5.374 0-10.127-2.756-13.03-6.959-.07.138-.151.271-.22.41a44.627 44.627 0 00-1.999 4.681c1.625 9.684 5.761 17.462 11.063 20.922l7.116-3.912c1.28-.7 2.07-2.05 2.07-3.51V36.163A15.454 15.454 0 0120 37z"}})])
          )
        }
      }
    